<script lang="ts" setup>
import { computed, defineAsyncComponent, defineModel } from '#imports'

const YscIconsDelete = defineAsyncComponent(() => import('./YscIconsDelete.vue'))

interface Props {
  permanent?: boolean
  variant?: 'info' | 'success' | 'warning' | 'danger' | 'default'
}

const display = defineModel<boolean>('display', { default: true })

const props = withDefaults(defineProps<Props>(), {
  permanent: false,
  variant: 'default',
})

const wrapperClass = computed(
  () =>
    ({
      info: 'border-peacock-400',
      success: 'border-green-500',
      warning: 'border-orange-500',
      danger: 'border-red-500',
      default: 'border-gray-300',
    })[props.variant || 'default'],
)

const close = () => {
  if (!props.permanent) {
    display.value = false
  }
}
</script>

<template>
  <div
    v-if="permanent || display"
    class="relative rounded border-[3px] bg-white py-4 pl-5 pr-10"
    :class="wrapperClass"
  >
    <button
      v-if="!permanent"
      type="button"
      name="close"
      class="absolute right-3 top-3"
      @click="close()"
    >
      <YscIconsDelete class="h-8 w-8" />
    </button>

    <slot />
  </div>
</template>
